import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import api from "../api";
import type { MastrData } from "../utils/backend-types";

export const mastrDataQueries = {
  all: () =>
    queryOptions({
      queryKey: ["mastrData"]
    }),
  detail: (mastrEinheitUrl?: string | null) =>
    queryOptions({
      queryKey: ["mastrData", { mastrEinheitUrl }],
      queryFn: mastrEinheitUrl
        ? () => fetchMastrData(mastrEinheitUrl)
        : skipToken,
      staleTime: 5 * 60 * 1000 // 5 min
    })
};

export function useMastrData(mastrEinheitUrl?: string | null) {
  return useQuery(mastrDataQueries.detail(mastrEinheitUrl));
}

async function fetchMastrData(mastrEinheitUrl: string) {
  const response = await api.get<MastrData>(mastrEinheitUrl);
  return response.data;
}
